export default {"src":"/_next/static/media/planning-smarter.7308944e.svg","height":32,"width":32};